import { toastError, toastSuccess } from '@components/Toast/Toast';
import { useBankProfile } from '@contexts/BankProfileContext';
import apiClient from '@services/apiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

const useDeleteTransactionsMultiple = () => {
	const { selectedProfile } = useBankProfile();
	const { t } = useTranslation('', { keyPrefix: 'listOfOperations' });
	const queryClient = useQueryClient();

	const deleteTransactions = async (props: { transactionIds: string[] }) => {
		const { transactionIds } = props;

		const response = await apiClient.post(
			`profiles/${selectedProfile?.id}/transactions/delete/multiple`,
			{
				transaction_uuids: transactionIds,
			},
		);

		return response.data;
	};

	return useMutation({
		mutationFn: deleteTransactions,
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: ['batch-transactions', selectedProfile?.id],
			});
			toastSuccess(t('deleteOperation.success'));
		},
		onError: async () => {
			toastError(t('deleteOperation.failed'));
		},
	});
};

export { useDeleteTransactionsMultiple };
